/*
 * Public API Surface of imprint
 */
import '@angular/localize/init';

export * from './lib/imprint.module';
export * from './lib/imprint.component';
